export const musicalStyles = [
  { id: 'sertanejo', label: 'Sertanejo', audioUrl: 'https://ula8sbsflkoyql15.public.blob.vercel-storage.com/Sertanejo.mp3' },
  { id: 'forro', label: 'Forró', audioUrl: 'https://ula8sbsflkoyql15.public.blob.vercel-storage.com/Forro%CC%81.mp3' },
  { id: 'mpb', label: 'MPB', audioUrl: 'https://ula8sbsflkoyql15.public.blob.vercel-storage.com/MPB.mp3' },
  { id: 'pagode', label: 'Pagode', audioUrl: 'https://ula8sbsflkoyql15.public.blob.vercel-storage.com/Pagode.mp3' },
  { id: 'gospel', label: 'Gospel', audioUrl: 'https://ula8sbsflkoyql15.public.blob.vercel-storage.com/Gospel.mp3' },
  { id: 'funk', label: 'Funk', audioUrl: 'https://ula8sbsflkoyql15.public.blob.vercel-storage.com/Funk.mp3' },
  { id: 'axe', label: 'Axé', audioUrl: 'https://ula8sbsflkoyql15.public.blob.vercel-storage.com/Axe%CC%81.mp3' },
  { id: 'bossanova', label: 'Bossa Nova', audioUrl: 'https://ula8sbsflkoyql15.public.blob.vercel-storage.com/Bossa%20Nova.mp3' },
  { id: 'pop', label: 'Pop', audioUrl: 'https://ula8sbsflkoyql15.public.blob.vercel-storage.com/Pop.mp3' },
  { id: 'samba', label: 'Samba', audioUrl: 'https://ula8sbsflkoyql15.public.blob.vercel-storage.com/Samba.mp3' },
  { id: 'arrocha', label: 'Arrocha', audioUrl: 'https://ula8sbsflkoyql15.public.blob.vercel-storage.com/Arrocha.mp3' },
  { id: 'rock', label: 'Rock', audioUrl: 'https://ula8sbsflkoyql15.public.blob.vercel-storage.com/Rock.mp3' },
  { id: 'eletronico', label: 'Eletrônico', audioUrl: 'https://ula8sbsflkoyql15.public.blob.vercel-storage.com/Eletro%CC%82nico.mp3' },
  { id: 'reggae', label: 'Reggae', audioUrl: 'https://ula8sbsflkoyql15.public.blob.vercel-storage.com/Reggae.mp3' },
];

export const occasions = [
  {
    id: 'maes',
    icon: 'ri-heart-2-line',
    title: 'Dia das Mães',
    description: 'Uma música que faz a mamãe chorar de emoção e amor.',
    href: '/presente-dia-das-maes',
  },
  {
    id: 'aniversario',
    icon: 'ri-cake-2-line',
    title: 'Aniversário',
    description: 'Surpreenda quem você ama com um parabéns que nunca vão esquecer.',
    href: '/presente-aniversario',
  },
  {
    id: 'casamento',
    icon: 'ri-sparkling-2-line',
    title: 'Pedido de Casamento',
    description: 'A trilha sonora perfeita para o maior sim da sua vida.',
    href: '/presente-casamento',
  },
  {
    id: 'formatura',
    icon: 'ri-graduation-cap-line',
    title: 'Formatura',
    description: 'Homenageie a conquista com uma música feita pela jornada deles.',
    href: '/presente-formatura',
  },
  {
    id: 'pais',
    icon: 'ri-user-heart-line',
    title: 'Dia dos Pais',
    description: 'Diga tudo que às vezes é difícil falar com palavras.',
    href: '/presente-dia-dos-pais',
  },
  {
    id: 'namorados',
    icon: 'ri-heart-3-line',
    title: 'Dia dos Namorados',
    description: 'Uma declaração de amor com a sua história em forma de música.',
    href: '/presente-dia-dos-namorados',
  },
  {
    id: 'natal',
    icon: 'ri-music-2-line',
    title: 'Natal',
    description: 'A trilha sonora da reunião de família mais especial do ano.',
    href: '/presente-natal',
  },
  {
    id: 'memorial',
    icon: 'ri-leaf-line',
    title: 'Homenagem Póstuma',
    description: 'Honre a memória de alguém especial com uma homenagem musical.',
    href: '/homenagem-para-avo',
  },
];

export const faqItems = [
  {
    id: 1,
    question: 'Como a música é criada?',
    answer: 'Você preenche um formulário contando a história da pessoa que quer homenagear — nome, momentos marcantes, estilo musical preferido. Nossa equipe de compositores cria uma música 100% original, com letra personalizada e melodia no estilo escolhido. O resultado é revisado com cuidado antes do envio.',
  },
  {
    id: 2,
    question: 'Em quanto tempo recebo a música?',
    answer: 'A entrega acontece em até 30 minutos diretamente no seu e-mail, em arquivo MP3 de alta qualidade. Em horários de alto volume pode levar um pouco mais, mas nunca mais do que 1 hora.',
  },
  {
    id: 3,
    question: 'A música realmente será única?',
    answer: 'Sim! Cada música é criada especificamente para você, com detalhes da história que você compartilhou. Nunca repetimos músicas — cada composição é exclusiva e não será usada para mais ninguém.',
  },
  {
    id: 4,
    question: 'Posso escolher o estilo musical?',
    answer: 'Claro! Você pode escolher entre sertanejo, forró, MPB, pagode, gospel, funk, axé, bossa nova, pop, samba, arrocha, rock, eletrônico e muito mais. Se tiver dúvida, você pode nos contar sobre a pessoa e nós sugerimos o estilo ideal.',
  },
  {
    id: 5,
    question: 'E se eu não gostar da música?',
    answer: 'Temos garantia de satisfação total. Se a música não te emocionar, devolvemos 100% do seu dinheiro, sem perguntas. Nossa prioridade é que você — e quem vai receber — se emocionem de verdade.',
  },
  {
    id: 6,
    question: 'Posso usar a música em vídeos ou redes sociais?',
    answer: 'Sim! Ao adquirir a música, você tem licença de uso pessoal completo — pode compartilhar em stories, reels, vídeos de formatura, cerimônias, homenagens e qualquer uso não comercial.',
  },
];

export const howItWorksSteps = [
  {
    id: 1,
    icon: 'ri-file-text-line',
    step: '01',
    title: 'Conte a história',
    description: 'Preencha um formulário rápido com detalhes da pessoa que você quer homenagear — nome, memórias, características e o estilo musical que ela ama.',
  },
  {
    id: 2,
    icon: 'ri-sparkling-line',
    step: '02',
    title: 'A música nasce',
    description: 'Nossos compositores criam uma música 100% original e exclusiva, com a letra personalizada e a melodia no estilo escolhido por você.',
  },
  {
    id: 3,
    icon: 'ri-mail-send-line',
    step: '03',
    title: 'Receba por WhatsApp ou E-mail',
    description: 'Em até 30 minutos, sua música personalizada chega em MP3 de alta qualidade diretamente no seu e-mail. Pronto para emocionar.',
  },
];

export type PricingPlan = {
  id: 'musica' | 'video';
  name: string;
  price: string;
  tagline: string;
  highlight: boolean;
  badge?: string;
  benefits: string[];
};

export const pricingPlans: PricingPlan[] = [
  {
    id: 'musica',
    name: 'Música',
    price: '34,90',
    tagline: 'Uma música personalizada, pronta para emocionar',
    highlight: false,
    benefits: [
      'Música 100% personalizada e exclusiva',
      'Letra com o nome e a história da pessoa',
      'Estilo e voz à sua escolha',
      'Áudio MP3 em alta qualidade',
      'Entrega em até 30 minutos',
    ],
  },
  {
    id: 'video',
    name: 'Música + Vídeo com Fotos',
    price: '49,90',
    tagline: 'Um presente completo, com acabamento profissional',
    highlight: true,
    badge: 'Mais escolhido',
    benefits: [
      'A mesma música personalizada em MP3',
      'Vídeo profissional com todas as fotos enviadas',
      'Tratamento e enquadramento das imagens',
      'Entrega em até 30 minutos',
    ],
  },
];
